const ACCESS_TOKEN_KEY = 'access_token'
const ACCESS_TOKEN_EXPIRES_AT_KEY = 'access_token_expires_at'
const ACCESS_TOKEN_WARNED_THRESHOLDS_KEY = 'access_token_warned_thresholds'

interface ITokenPayload {
    token?: string,
    token_type?: string,
    expires_at?: string,
}

export const useToken = () => {
    const getToken = (): any => {
        return window.localStorage.getItem(ACCESS_TOKEN_KEY)
    }

    const getExpiresAt = (): string | null => {
        return window.localStorage.getItem(ACCESS_TOKEN_EXPIRES_AT_KEY)
    }

    const setExpiresAt = (expiresAt: string): void => {
        window.localStorage.setItem(ACCESS_TOKEN_EXPIRES_AT_KEY, expiresAt)
    }

    const setToken = (payload: ITokenPayload): boolean => {
        window.localStorage.setItem(ACCESS_TOKEN_KEY, payload.token + '')
        window.localStorage.removeItem(ACCESS_TOKEN_WARNED_THRESHOLDS_KEY)

        if (payload.expires_at) {
            window.localStorage.setItem(ACCESS_TOKEN_EXPIRES_AT_KEY, payload.expires_at)
        }

        return true
    }

    const clearToken = (): boolean => {
        window.localStorage.removeItem(ACCESS_TOKEN_KEY)
        window.localStorage.removeItem(ACCESS_TOKEN_EXPIRES_AT_KEY)
        window.localStorage.removeItem(ACCESS_TOKEN_WARNED_THRESHOLDS_KEY)
        return true
    }

    const getWarnedExpiryThresholds = (): number[] => {
        try {
            return JSON.parse(window.localStorage.getItem(ACCESS_TOKEN_WARNED_THRESHOLDS_KEY) ?? '[]')
        } catch {
            return []
        }
    }

    const addWarnedExpiryThreshold = (thresholdMs: number): void => {
        const thresholds = getWarnedExpiryThresholds()

        if (!thresholds.includes(thresholdMs)) {
            window.localStorage.setItem(
                ACCESS_TOKEN_WARNED_THRESHOLDS_KEY,
                JSON.stringify([...thresholds, thresholdMs]),
            )
        }
    }

    return {
        getToken,
        getExpiresAt,
        setExpiresAt,
        setToken,
        clearToken,
        getWarnedExpiryThresholds,
        addWarnedExpiryThreshold,
    }
}